var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-unit-modal" }, [
    _c(
      "form",
      {
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitContactData($event)
          },
        },
      },
      [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-group row" }, [
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("settings.contacts.name"))),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                _vm._v(" "),
                _c("base-input", {
                  ref: "name",
                  attrs: {
                    invalid: _vm.$v.formData.name.$error,
                    type: "text",
                    name: "name",
                    "tab-index": "1",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.name.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "name", $$v)
                    },
                    expression: "formData.name",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.name.$error
                  ? _c("div", [
                      !_vm.$v.formData.name.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$tc("validation.name_required")) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.formData.name.minLength
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$tc(
                                    "validation.name_min_length",
                                    _vm.$v.formData.name.$params.minLength.min,
                                    {
                                      count:
                                        _vm.$v.formData.name.$params.minLength
                                          .min,
                                    }
                                  )
                                ) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-12 mt-3" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("settings.contacts.email"))),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                _vm._v(" "),
                _c("base-input", {
                  attrs: {
                    invalid: _vm.$v.formData.email.$error,
                    type: "text",
                    name: "email",
                    "tab-index": "3",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.email.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.email,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.formData,
                        "email",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formData.email",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.email.$error
                  ? _c("div", [
                      !_vm.$v.formData.email.email
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$tc("validation.email_incorrect")) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.formData.email.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$tc("validation.email_required")) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-12 mt-3" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("settings.contacts.contact_number"))),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                _vm._v(" "),
                _c("base-input", {
                  attrs: {
                    invalid: _vm.$v.formData.contact_number.$error,
                    type: "number",
                    name: "phone",
                    "tab-index": "4",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.contact_number.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.contact_number,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.formData,
                        "contact_number",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formData.contact_number",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.contact_number.$error
                  ? _c("div", [
                      !_vm.$v.formData.contact_number.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n                   " +
                                _vm._s(_vm.$tc("validation.Number_required")) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-12 mt-3" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("settings.contacts.designation"))),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                _vm._v(" "),
                _c("base-input", {
                  attrs: {
                    invalid: _vm.$v.formData.designation.$error,
                    type: "text",
                    "tab-index": "4",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.designation.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.designation,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.formData,
                        "designation",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formData.designation",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.designation.$error
                  ? _c("div", [
                      !_vm.$v.formData.designation.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n                   " +
                                _vm._s(
                                  _vm.$tc("validation.designation_required")
                                ) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-footer" },
          [
            _c(
              "base-button",
              {
                staticClass: "mr-3",
                attrs: { outline: true, color: "theme", type: "button" },
                on: { click: _vm.closeContactModal },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("general.cancel")) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "base-button",
              {
                attrs: {
                  loading: _vm.isLoading,
                  disabled: _vm.isSubmitDisabled,
                  color: "theme",
                  icon: "save",
                  type: "submit",
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      !_vm.isEdit
                        ? _vm.$t("general.save")
                        : _vm.$t("general.update")
                    ) +
                    "\n      "
                ),
              ]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }